import { ResponsiveContainer, RadarChart, PolarGrid, PolarAngleAxis, PolarRadiusAxis, Radar, Legend, Tooltip } from "recharts";
import { useT } from "../../contexts/LanguageContext";

export default function DomainRadar({ data }) {
  const { t, tDomain } = useT();
  const chartData = (data || []).map((d) => ({
    domain: tDomain(d.domain),
    current: d.current,
    best: d.best,
  }));
  return (
    <div className="card lg:col-span-4" data-testid="domain-radar">
      <div className="overline">{t("analytics.radar_overline")}</div>
      <h3 className="font-display text-xl font-semibold mt-1">{t("analytics.radar_title")}</h3>
      <div className="h-64 mt-3" style={{ minHeight: 240 }}>
        <ResponsiveContainer width="100%" height="100%">
          <RadarChart data={chartData} outerRadius="75%">
            <PolarGrid stroke="#E2E8F0" />
            <PolarAngleAxis dataKey="domain" tick={{ fontSize: 11, fill: "#475569" }} />
            <PolarRadiusAxis angle={90} domain={[0, 100]} tick={{ fontSize: 10, fill: "#94A3B8" }} tickCount={5} />
            <Tooltip contentStyle={{ background: "#0F172A", border: "none", borderRadius: 6, color: "#fff", fontSize: 12 }} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Radar name={t("analytics.best")} dataKey="best" stroke="#94A3B8" fill="#94A3B8" fillOpacity={0.2} />
            <Radar name={t("analytics.current")} dataKey="current" stroke="#002FA7" fill="#002FA7" fillOpacity={0.45} />
          </RadarChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
